import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import { RootState } from "../../reducers/index";
import { InfoState } from "../../reducers/components/InforReducer";
import { useDispatch, useSelector } from "react-redux";

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// interface InfoDisplayProps {
//   duration?:2000;
// }

export default function InfoDisplay() {
  //const {duration} = props;
  const infoData = useSelector<RootState, InfoState>(
    (state) => state.infoDisplayDetails
  );
  const dispatch = useDispatch();

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch({
      type: "ON_CLOSE_INFO_DISPLAY",
      payload: [],
    });
  };

  return (
    <div>
      <Snackbar
        open={infoData.open}
        autoHideDuration={infoData.duration}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={infoData.severity}>
          {infoData.infoMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}
